import React, { FC, useEffect, useState } from "react";

import { LocationDto } from "@apiModels/LocationDto.csharp";

import { DoctorBarAppointment } from "./Components/DoctorBarAppointment";
import { DoctorBarPricing } from "./Components/DoctorBarPricing";
import { DoctorBarTreaterButton } from "./Components/DoctorBarTreaterButton";
import { DoctorBarStatus } from "./Types/types";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";

export interface DoctorsListModel extends InsuranceDoctorDto {
  price?: number;
  date?: Date;
}

interface DoctorBarProps {
  doctor: DoctorsListModel;
  locations: LocationDto[];
  isAuthenticated: boolean;
  doctorUrl: string;
  barStatus?: DoctorBarStatus;
}

export const DoctorBar: FC<DoctorBarProps> = (props) => {
  const { doctor, locations, isAuthenticated, barStatus, doctorUrl } = props;

  const [barState, setBarState] = useState<DoctorBarStatus>(
    barStatus ?? "noFilters"
  );

  useEffect(() => {
    if (barStatus) {
      setBarState(barStatus);
    }
  }, [barStatus]);

  return (
    <div className="doctorBar">
      <div className="doctorBar__doctor">
        <img
          className="doctorBar__doctorImage"
          src={`${doctor.pictureUrl}?width=80&height=80&rmode=crop&ranchor=top`}
          alt={doctor.name}
        />
        <div className="doctorBar__doctorInfo">
          <span className="fw-bold d-block">{doctor.name}</span>
          {doctor.jobTitle && (
            <span className="d-block">{doctor.jobTitle}</span>
          )}
        </div>
      </div>
      <div className="doctorBar__department doctorBar__placeholderText">
        {doctor.department}
      </div>
      <div className="doctorBar__location">
        {locations.map((loc) => (
          <div key={loc.id}>{loc.name}</div>
        ))}
      </div>
      <DoctorBarPricing
        barState={barState}
        isAuthenticated={isAuthenticated}
        price={doctor.price}
      />
      <DoctorBarAppointment barState={barState} date={doctor.date} />
      <DoctorBarTreaterButton doctorUrl={doctorUrl} barState={barState} />
    </div>
  );
};
